import {Address} from './address.js';

export var Addresses = function(addressesData) {
    var addresses = {};
    
    // Constructor
    if (addressesData) {
        if (addressesData.default) {
            addresses.default = Address(addressesData.default);
        }
        if (addressesData.local) {
            addresses.local = Address(addressesData.local);
        }
        if (addressesData.nonLocal) {
            addresses.nonLocal = Address(addressesData.nonLocal);
        }
        if (addressesData.local2) {
            addresses.local2 = Address(addressesData.local2);
        }
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    addresses.getAnAddress = function() {
        var anAddress;

        if (addresses.default) {
            anAddress = addresses.default;
        } else if (addresses.local) {
            anAddress = addresses.local;
        } else if (addresses.local2) {
            anAddress = addresses.local2;
        } else if (addresses.nonLocal) {
            anAddress = addresses.nonLocal;
        }

        return anAddress;
    };
    
    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    
    return addresses;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/addresses.js
// module id = 35
// module chunks = 0